import {
  FETCH_INITIAL_STATEMENTS_DATA_REQUEST,
    FETCH_INITIAL_STATEMENTS_DATA_SUCCESS,
    FETCH_INITIAL_STATEMENTS_DATA_FAILURE,
  } from "./FetchInitialStatementsDataTypes";
  
  const initialState = {
    loading: false,
    initialStatementsData: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_INITIAL_STATEMENTS_DATA_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_INITIAL_STATEMENTS_DATA_SUCCESS:
        return {
          loading: false,
          initialStatementsData: action.payload,
          error: "",
        };
      case FETCH_INITIAL_STATEMENTS_DATA_FAILURE:
        return {
          loading: false,
          initialStatementsData: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  